import api from './api';

const REGION_COOKIE = 'tx_region';
const STORAGE_KEY = 'tx_region_cache';

function readCookie(name) {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function readFromCookie() {
    try {
        const raw = readCookie(REGION_COOKIE);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function readFromStorage() {
    try {
        const raw = window.localStorage?.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function writeToStorage(value) {
    try {
        window.localStorage?.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
        /* ignore */
    }
}

export const regionService = {
    getCached() {
        return readFromCookie() || readFromStorage();
    },

    async fetch() {
        const response = await api.get('/region');
        const data = response.data || {};
        writeToStorage(data);
        return data;
    },

    async getOrFetch() {
        const cached = this.getCached();
        if (cached && cached.country) return cached;
        try {
            return await this.fetch();
        } catch (e) {
            return cached || {};
        }
    },
};

export default regionService;
